import * as React from 'react';
import '../../../panels/panels.css';
import {
    Button,
    Label,
    Segment,
    Form,
    Checkbox,
    Dropdown,
    Input,
    Radio,
    Modal,
    Icon,
    Header
} from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    dashVodCont: boolean;
    dashStreamIdReq: boolean;
    dashRedirectMpd: boolean;
    dashRedirectMedia: boolean;
    dashShareConn: boolean;
    dashPersistConn: boolean;
    dashSidxNonSegTimelineMediaDur: boolean;
    dashSidxSegTimelineMediaDur: boolean;
    dashMpdGzip: boolean;
    dashMpdReqMode: any;
    dashInitReqMode: any;
    dashAutoStartComp: string;
    dashVarNameOptRepId: boolean;
    dashVarNameOptBandwidth: boolean;
    dashVarNameOptResolution: boolean;
    dashVarNameOptLang: boolean;
    dashVarNameOptType: boolean;
    dashAutoStartCompAllVideo: boolean;
    dashAutoStartCompAllAudio: boolean;
    dashAutoStartCompAllText: boolean;
    dashAutoStartCompLimitVideo: boolean;
    dashAutoStartCompLimitAudio: boolean;
    dashAutoStartCompLimitText: boolean;
    dashAutoStartCompLimitVideoVar: string;
    dashAutoStartCompLimitAudioVar: string;
    dashAutoStartCompLimitTextVar: string;
    dashVarNameOptPatternMatch: boolean;
    dashMediaFileStartPos: any;
    dashCookieMode: boolean;
    dashProfileChkMode: any;
    dashDaiEnable: boolean;
    dashDecrypt: boolean;
    dashMpdShare: boolean;
    dashPersistConnTimeout: any;
    dashRedirectMpdVariantInherit: boolean;
    dashVarNameOptCodec: boolean;
    dashVarNameOptSubRepBandwidth: boolean;
    dashVarNameOptContentComponent: boolean;
    dashSubRepresentationsEnable: boolean;
    dashImageVariantsEnable: boolean;
    dashAutoStartCompAllImage: boolean;
    dashAutoStartCompLimitImage: boolean;
    dashAutoStartCompLimitImageVar: string;
    dashAutoStartCompAllSubRep: boolean;
    dashAutoStartCompLimitSubRep: boolean;
    dashVarNameOptDaiPeriodId: boolean;
    dashVarNameOptDaiAd: boolean;
    dashMpdVariantResync: boolean;
    timeoutHelpModalOpen: boolean;
    dashQoeAllVideo: boolean;
    dashQoeAllAudio: boolean;
    dashQoeAllPixel: boolean;
    dashQoeLimitVideo: boolean;
    dashQoeLimitAudio: boolean;
    dashQoeLimitPixel: boolean;
    dashQoeAllSubRep: boolean;
    dashQoeLimitSubRep: boolean;
    dashMpdChangeDynamicToStaticEnable: boolean;
    dashMpdChangeStaticToDynamicEnable: boolean;
}

interface Props {

}

export default class MPEGAdaptiveStreamConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            dashVodCont: false,
            dashStreamIdReq: false,
            dashRedirectMpd: false,
            dashRedirectMedia: false,
            dashShareConn: false,
            dashPersistConn: false,
            dashSidxNonSegTimelineMediaDur: false,
            dashSidxSegTimelineMediaDur: false,
            dashMpdGzip: false,
            dashMpdReqMode: '',
            dashInitReqMode: '',
            dashAutoStartComp: '',
            dashVarNameOptRepId: false,
            dashVarNameOptBandwidth: false,
            dashVarNameOptResolution: false,
            dashVarNameOptLang: false,
            dashVarNameOptType: false,
            dashAutoStartCompAllVideo: false,
            dashAutoStartCompAllAudio: false,
            dashAutoStartCompAllText: false,
            dashAutoStartCompLimitVideo: false,
            dashAutoStartCompLimitAudio: false,
            dashAutoStartCompLimitText: false,
            dashAutoStartCompLimitVideoVar: '',
            dashAutoStartCompLimitAudioVar: '',
            dashAutoStartCompLimitTextVar: '',
            dashVarNameOptPatternMatch: false,
            dashMediaFileStartPos: '',
            dashCookieMode: false,
            dashProfileChkMode: '',
            dashDaiEnable: false,
            dashDecrypt: false,
            dashMpdShare: false,
            dashPersistConnTimeout: '',
            dashRedirectMpdVariantInherit: false,
            dashVarNameOptCodec: false,
            dashVarNameOptSubRepBandwidth: false,
            dashVarNameOptContentComponent: false,
            dashSubRepresentationsEnable: false,
            dashImageVariantsEnable: false,
            dashAutoStartCompAllImage: false,
            dashAutoStartCompLimitImage: false,
            dashAutoStartCompLimitImageVar: '',
            dashAutoStartCompAllSubRep: false,
            dashAutoStartCompLimitSubRep: false,
            dashVarNameOptDaiPeriodId: false,
            dashVarNameOptDaiAd: false,
            dashMpdVariantResync: false,
            timeoutHelpModalOpen: false,
            dashQoeAllVideo: false,
            dashQoeAllAudio: false,
            dashQoeAllPixel: false,
            dashQoeLimitVideo: false,
            dashQoeLimitAudio: false,
            dashQoeLimitPixel: false,
            dashQoeAllSubRep: false,
            dashQoeLimitSubRep: false,
            dashMpdChangeDynamicToStaticEnable: false,
            dashMpdChangeStaticToDynamicEnable: false
        });

        this.fetchData();
        this.setTimeoutHelpModalOpen = this.setTimeoutHelpModalOpen.bind(this);
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {},
            options: [
                'dashVodCont', 'dashStreamIdReq', 'dashRedirectMpd', 'dashRedirectMedia', 'dashShareConn', 'dashPersistConn',
                'dashSidxNonSegTimelineMediaDur', 'dashMpdGzip', 'dashMpdReqMode', 'dashInitReqMode', 'dashAutoStartComp', 'dashVarNameOptRepId',
                'dashVarNameOptBandwidth', 'dashVarNameOptResolution', 'dashVarNameOptLang', 'dashVarNameOptType', 'dashAutoStartCompAllVideo',
                'dashAutoStartCompAllAudio', 'dashAutoStartCompAllText', 'dashAutoStartCompLimitVideo', 'dashAutoStartCompLimitAudio',
                'dashAutoStartCompLimitText', 'dashAutoStartCompLimitVideoVar', 'dashAutoStartCompLimitAudioVar', 'dashAutoStartCompLimitTextVar',
                'dashVarNameOptPatternMatch', 'dashMediaFileStartPos', 'dashCookieMode', 'dashProfileChkMode', 'dashDaiEnable', 'dashDecrypt', 'dashSidxSegTimelineMediaDur',
                'dashMpdShare', 'dashPersistConnTimeout', 'dashRedirectMpdVariantInherit', 'dashVarNameOptCodec', 'dashVarNameOptSubRepBandwidth', 'dashVarNameOptContentComponent',
                'dashSubRepresentationsEnable', 'dashImageVariantsEnable', 'dashAutoStartCompAllImage', 'dashAutoStartCompLimitImage', 'dashAutoStartCompLimitImageVar',
                'dashAutoStartCompAllSubRep', 'dashAutoStartCompLimitSubRep', 'dashVarNameOptDaiPeriodId', 'dashVarNameOptDaiAd', 'dashMpdVariantResync',
                'dashQoeAllVideo', 'dashQoeAllAudio', 'dashQoeAllPixel', 'dashQoeLimitVideo', 'dashQoeLimitAudio', 'dashQoeLimitPixel', 'dashQoeAllSubRep', 'dashQoeLimitSubRep',
                'dashMpdChangeDynamicToStaticEnable', 'dashMpdChangeStaticToDynamicEnable'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        dashVodCont: responseObject[0].value,
                        dashStreamIdReq: responseObject[1].value,
                        dashRedirectMpd: responseObject[2].value,
                        dashRedirectMedia: responseObject[3].value,
                        dashShareConn: responseObject[4].value,
                        dashPersistConn: responseObject[5].value,
                        dashSidxNonSegTimelineMediaDur: responseObject[6].value,
                        dashMpdGzip: responseObject[7].value,
                        dashMpdReqMode: responseObject[8].value,
                        dashInitReqMode: responseObject[9].value,
                        dashAutoStartComp: responseObject[10].value,
                        dashVarNameOptRepId: responseObject[11].value,
                        dashVarNameOptBandwidth: responseObject[12].value,
                        dashVarNameOptResolution: responseObject[13].value,
                        dashVarNameOptLang: responseObject[14].value,
                        dashVarNameOptType: responseObject[15].value,
                        dashAutoStartCompAllVideo: responseObject[16].value,
                        dashAutoStartCompAllAudio: responseObject[17].value,
                        dashAutoStartCompAllText: responseObject[18].value,
                        dashAutoStartCompLimitVideo: responseObject[19].value,
                        dashAutoStartCompLimitAudio: responseObject[20].value,
                        dashAutoStartCompLimitText: responseObject[21].value,
                        dashAutoStartCompLimitVideoVar: responseObject[22].value,
                        dashAutoStartCompLimitAudioVar: responseObject[23].value,
                        dashAutoStartCompLimitTextVar: responseObject[24].value,
                        dashVarNameOptPatternMatch: responseObject[25].value,
                        dashMediaFileStartPos: responseObject[26].value,
                        dashCookieMode: responseObject[27].value,
                        dashProfileChkMode: responseObject[28].value,
                        dashDaiEnable: responseObject[29].value,
                        dashDecrypt: responseObject[30].value,
                        dashSidxSegTimelineMediaDur: responseObject[31].value,
                        dashMpdShare: responseObject[32].value,
                        dashPersistConnTimeout: responseObject[33].value,
                        dashRedirectMpdVariantInherit: responseObject[34].value,
                        dashVarNameOptCodec: responseObject[35].value,
                        dashVarNameOptSubRepBandwidth: responseObject[36].value,
                        dashVarNameOptContentComponent: responseObject[37].value,
                        dashSubRepresentationsEnable: responseObject[38].value,
                        dashImageVariantsEnable: responseObject[39].value,
                        dashAutoStartCompAllImage: responseObject[40].value,
                        dashAutoStartCompLimitImage: responseObject[41].value,
                        dashAutoStartCompLimitImageVar: responseObject[42].value,
                        dashAutoStartCompAllSubRep: responseObject[43].value,
                        dashAutoStartCompLimitSubRep: responseObject[44].value,
                        dashVarNameOptDaiPeriodId: responseObject[45].value,
                        dashVarNameOptDaiAd: responseObject[46].value,
                        dashMpdVariantResync: responseObject[47].value,
                        dashQoeAllVideo: responseObject[48].value,
                        dashQoeAllAudio: responseObject[49].value,
                        dashQoeAllPixel: responseObject[50].value,
                        dashQoeLimitVideo: responseObject[51].value,
                        dashQoeLimitAudio: responseObject[52].value,
                        dashQoeLimitPixel: responseObject[53].value,
                        dashQoeAllSubRep: responseObject[54].value,
                        dashQoeLimitSubRep: responseObject[55].value,
                        dashMpdChangeDynamicToStaticEnable: responseObject[56].value,
                        dashMpdChangeStaticToDynamicEnable: responseObject[57].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {},
            options: [
                {'name': 'dashVodCont', 'value': this.state.dashVodCont},
                {'name': 'dashStreamIdReq', 'value': this.state.dashStreamIdReq},
                {'name': 'dashRedirectMpd', 'value': this.state.dashRedirectMpd},
                {'name': 'dashRedirectMedia', 'value': this.state.dashRedirectMedia},
                {'name': 'dashShareConn', 'value': this.state.dashShareConn},
                {'name': 'dashPersistConn', 'value': this.state.dashPersistConn},
                {'name': 'dashSidxNonSegTimelineMediaDur', 'value': this.state.dashSidxNonSegTimelineMediaDur},
                {'name': 'dashSidxSegTimelineMediaDur', 'value': this.state.dashSidxSegTimelineMediaDur},
                {'name': 'dashMpdGzip', 'value': this.state.dashMpdGzip},
                {'name': 'dashMpdReqMode', 'value': this.state.dashMpdReqMode},
                {'name': 'dashInitReqMode', 'value': this.state.dashInitReqMode},
                {'name': 'dashAutoStartComp', 'value': this.state.dashAutoStartComp},
                {'name': 'dashVarNameOptRepId', 'value': this.state.dashVarNameOptRepId},
                {'name': 'dashVarNameOptBandwidth', 'value': this.state.dashVarNameOptBandwidth},
                {'name': 'dashVarNameOptResolution', 'value': this.state.dashVarNameOptResolution},
                {'name': 'dashVarNameOptLang', 'value': this.state.dashVarNameOptLang},
                {'name': 'dashVarNameOptType', 'value': this.state.dashVarNameOptType},
                {'name': 'dashAutoStartCompAllVideo', 'value': this.state.dashAutoStartCompAllVideo},
                {'name': 'dashAutoStartCompAllAudio', 'value': this.state.dashAutoStartCompAllAudio},
                {'name': 'dashAutoStartCompAllText', 'value': this.state.dashAutoStartCompAllText},
                {'name': 'dashAutoStartCompLimitVideo', 'value': this.state.dashAutoStartCompLimitVideo},
                {'name': 'dashAutoStartCompLimitAudio', 'value': this.state.dashAutoStartCompLimitAudio},
                {'name': 'dashAutoStartCompLimitText', 'value': this.state.dashAutoStartCompLimitText},
                {'name': 'dashAutoStartCompLimitVideoVar', 'value': this.state.dashAutoStartCompLimitVideoVar},
                {'name': 'dashAutoStartCompLimitAudioVar', 'value': this.state.dashAutoStartCompLimitAudioVar},
                {'name': 'dashAutoStartCompLimitTextVar', 'value': this.state.dashAutoStartCompLimitTextVar},
                {'name': 'dashVarNameOptPatternMatch', 'value': this.state.dashVarNameOptPatternMatch},
                {'name': 'dashMediaFileStartPos', 'value': this.state.dashMediaFileStartPos},
                {'name': 'dashCookieMode', 'value': this.state.dashCookieMode},
                {'name': 'dashProfileChkMode', 'value': this.state.dashProfileChkMode},
                {'name': 'dashDaiEnable', 'value': this.state.dashDaiEnable},
                {'name': 'dashDecrypt', 'value': this.state.dashDecrypt},
                {'name': 'dashMpdShare', 'value': this.state.dashMpdShare},
                {'name': 'dashPersistConnTimeout', 'value': this.state.dashPersistConnTimeout},
                {'name': 'dashRedirectMpdVariantInherit', 'value': this.state.dashRedirectMpdVariantInherit},
                {'name': 'dashVarNameOptCodec', 'value': this.state.dashVarNameOptCodec},
                {'name': 'dashVarNameOptSubRepBandwidth', 'value': this.state.dashVarNameOptSubRepBandwidth},
                {'name': 'dashVarNameOptContentComponent', 'value': this.state.dashVarNameOptContentComponent},
                {'name': 'dashSubRepresentationsEnable', 'value': this.state.dashSubRepresentationsEnable},
                {'name': 'dashImageVariantsEnable', 'value': this.state.dashImageVariantsEnable},
                {'name': 'dashAutoStartCompAllImage', 'value': this.state.dashAutoStartCompAllImage},
                {'name': 'dashAutoStartCompLimitImage', 'value': this.state.dashAutoStartCompLimitImage},
                {'name': 'dashAutoStartCompLimitImageVar', 'value': this.state.dashAutoStartCompLimitImageVar},
                {'name': 'dashAutoStartCompAllSubRep', 'value': this.state.dashAutoStartCompAllSubRep},
                {'name': 'dashAutoStartCompLimitSubRep', 'value': this.state.dashAutoStartCompLimitSubRep},
                {'name': 'dashVarNameOptDaiPeriodId', 'value': this.state.dashVarNameOptDaiPeriodId},
                {'name': 'dashVarNameOptDaiAd', 'value': this.state.dashVarNameOptDaiAd},
                {'name': 'dashMpdVariantResync', 'value': this.state.dashMpdVariantResync},
                {'name': 'dashQoeAllVideo', 'value': this.state.dashQoeAllVideo},
                {'name': 'dashQoeAllAudio', 'value': this.state.dashQoeAllAudio},
                {'name': 'dashQoeAllPixel', 'value': this.state.dashQoeAllPixel},
                {'name': 'dashQoeLimitVideo', 'value': this.state.dashQoeLimitVideo},
                {'name': 'dashQoeLimitAudio', 'value': this.state.dashQoeLimitAudio},
                {'name': 'dashQoeLimitPixel', 'value': this.state.dashQoeLimitPixel},
                {'name': 'dashQoeAllSubRep', 'value': this.state.dashQoeAllSubRep},
                {'name': 'dashQoeLimitSubRep', 'value': this.state.dashQoeLimitSubRep},
                {'name': 'dashMpdChangeDynamicToStaticEnable', 'value': this.state.dashMpdChangeDynamicToStaticEnable},
                {'name': 'dashMpdChangeStaticToDynamicEnable', 'value': this.state.dashMpdChangeStaticToDynamicEnable}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('MPEG / Dynamic Adaptive Streaming configuration applied');
                } else {
                    Toast.error('MPEG / Dynamic Adaptive Streaming configuration failed');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('MPEG / Dynamic Adaptive Streaming configuration failed');
            });
    }

    // Set the Timeout help Modal to open/closed
    setTimeoutHelpModalOpen(isOpen: boolean) {
        this.setState({timeoutHelpModalOpen: isOpen});
    }

    toggleVideo(index: any) {
        if (index === 1) {
            if (this.state.dashQoeAllVideo) {
                this.setState({dashQoeAllVideo: false, dashQoeAllPixel: false});
            } else {
                this.setState({dashQoeAllVideo: true});
            }
        } else {
            if (this.state.dashQoeLimitVideo) {
                this.setState({dashQoeLimitVideo: false, dashQoeLimitPixel: false});
            } else {
                this.setState({dashQoeLimitVideo: true});
            }
        }
    }

    render() {
        const mpdFileReqOptions = [
            {value: 'min', text: 'Minimum Update Period'},
            {value: 25, text: '25 Media'},
            {value: 50, text: '50 Media'},
            {value: 100, text: '100 Media'}
        ];
        const initializationFileReqOptions = [
            {value: 'never', text: 'Never'},
            {value: 'init', text: 'Init'},
            {value: '100', text: '100'},
            {value: '1000', text: '1000'}
        ];
        const mediaFileStartPosOptions = [
            {value: 'auto', text: 'Auto'},
            {value: 'begin', text: 'Begin'},
            {value: 'end', text: 'End'}
        ];
        const dashProfileChkModeOptions = [
            {value: 'ignore', text: 'Ignore'},
            {value: 'warn', text: 'Warn'},
            {value: 'fail', text: 'Fail'}
        ];

        const dashStreamingOptions = [
            {stateName: 'dashVodCont', label: 'Play VOD Streams Continuously'},
            {stateName: 'dashStreamIdReq', label: 'Include Stream Identifier Cookie In HTTP Requests'},
            {stateName: 'dashRedirectMpd', label: 'Enable MPD Redirect'},
            {stateName: 'dashRedirectMpdVariantInherit', label: 'Variants inherit MPD Redirect'},
            {stateName: 'dashRedirectMedia', label: 'Enable Media Redirect'},
            {stateName: 'dashShareConn', label: 'Enable Shared MPD/Media Connections'},
            {stateName: 'dashPersistConn', label: 'Enable Persistent Connections'},
            {stateName: 'dashDecrypt', label: 'Enable Decryption'},
            {
                stateName: 'dashSidxNonSegTimelineMediaDur',
                label: 'Use Segment Index Box For Media Duration Non-Segment Timeline'
            },
            {
                stateName: 'dashSidxSegTimelineMediaDur',
                label: 'Use Segment Index Box For Media Duration Segment Timeline'
            },
            {stateName: 'dashCookieMode', label: 'Enable Cookies'},
            {stateName: 'dashMpdGzip', label: 'Enable MPD GZIP Compression'},
            {stateName: 'dashMpdVariantResync', label: 'Enable Variant Resync on MPD change'},
            {stateName: 'dashMpdShare', label: 'Enable MPD Sharing'},
            {stateName: 'dashSubRepresentationsEnable', label: 'Enable Sub-Representations'},
            {stateName: 'dashImageVariantsEnable', label: 'Enable Image Variants'},
            {stateName: 'dashMpdChangeDynamicToStaticEnable', label: 'Enable MPD change from dynamic to static'},
            {stateName: 'dashMpdChangeStaticToDynamicEnable', label: 'Enable MPD change from static to dynamic'},
        ];

        const dashVariantNameOptions = [
            {stateName: 'dashVarNameOptRepId', label: 'Representation Identifier'},
            {stateName: 'dashVarNameOptBandwidth', label: 'Bandwidth'},
            {stateName: 'dashVarNameOptSubRepBandwidth', label: 'Sub-Representation Bandwidth'},
            {stateName: 'dashVarNameOptResolution', label: 'Resolution'},
            {stateName: 'dashVarNameOptCodec', label: 'Codec'},
            {stateName: 'dashVarNameOptContentComponent', label: 'Content Component'},
            {stateName: 'dashVarNameOptLang', label: 'Language'},
            {stateName: 'dashVarNameOptType', label: 'Type'}
        ];

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    MPEG/Dynamic Adaptive Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Streaming Options</Segment>
                                    <Segment>
                                        <Form>
                                            {!oauth.VODOnlyLicensePresent ?
                                                dashStreamingOptions.map((streamingOption, index) => {
                                                    return <Form.Group grouped key={streamingOption.stateName}>
                                                        <Checkbox
                                                            className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                            checked={this.state[streamingOption.stateName]}
                                                            onChange={(e: any, data: any) => this.setState({
                                                                ...this.state,
                                                                [streamingOption.stateName]: data.checked
                                                            })}
                                                        />
                                                        <Label
                                                            className={(streamingOption.stateName === 'dashPersistConn' || 'dashMpdVariantResync') ? 'left-align-label-min150' : 'left-align-label-500'}
                                                        >
                                                            {streamingOption.label}
                                                        </Label>
                                                        {streamingOption.stateName === 'dashPersistConn' &&
                                                        <>
                                                            <Label
                                                                className={!this.state.dashPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}
                                                            >
                                                                Timeout (seconds)
                                                            </Label>
                                                            <Input
                                                                className="small-input"
                                                                disabled={!this.state.dashPersistConn}
                                                                type="number"
                                                                min="0"
                                                                max="600"
                                                                value={this.state.dashPersistConnTimeout}
                                                                onChange={(e: any, data: any) => this.setState({dashPersistConnTimeout: data.value})}
                                                            />
                                                        </>
                                                        }
                                                        {streamingOption.stateName === 'dashMpdVariantResync' &&
                                                        <Modal
                                                            closeIcon
                                                            onClose={() => this.setTimeoutHelpModalOpen(false)}
                                                            onOpen={() => this.setTimeoutHelpModalOpen(true)}
                                                            open={this.state.timeoutHelpModalOpen}
                                                            size="small"
                                                            trigger={<Icon
                                                                name="question circle"
                                                                size="small"
                                                                style={{paddingLeft: '10px'}}
                                                            />}
                                                        >
                                                            <Header as="h5" icon className="speedModalHeader">
                                                                Enable Variant Resync
                                                            </Header>
                                                            <Modal.Content>
                                                                <p>
                                                                    {/* tslint:disable-next-line:max-line-length */}
                                                                    When enabled, if an updated Media Presentation
                                                                    Description (MPD) has a different number of
                                                                    representations or representations that were present
                                                                    in
                                                                    a previous MPD are no longer present, all variants
                                                                    will
                                                                    be deleted and new variants will be recreated based
                                                                    on
                                                                    latest MPD. The representation identifier field is
                                                                    the
                                                                    only attribute that is used to determine if
                                                                    representations are different. Other attributes such
                                                                    as
                                                                    bandwidth and MIME type are allowed to change as
                                                                    long as
                                                                    the representation identifier does not.
                                                                </p>
                                                                <p>
                                                                    {/* tslint:disable-next-line:max-line-length */}
                                                                    <b>Note:</b> In the case of MPDs with multiple
                                                                    periods,
                                                                    this representation resync will not occur. Period
                                                                    change
                                                                    logic will handle representation changes that either
                                                                    do
                                                                    or do not persist across periods by adding and
                                                                    removing
                                                                    variants based on representations detected in
                                                                    periods.
                                                                </p>
                                                            </Modal.Content>
                                                        </Modal>
                                                        }
                                                    </Form.Group>;
                                                })
                                                : null}
                                            {!oauth.VODOnlyLicensePresent ?
                                                <Form.Group grouped>
                                                    <Label
                                                        className="left-align-label-min200"
                                                        style={{paddingLeft: '10%'}}
                                                    >
                                                        MPD File Request Mode
                                                    </Label>
                                                    <Dropdown
                                                        search
                                                        value={this.state.dashMpdReqMode}
                                                        options={mpdFileReqOptions}
                                                        selection
                                                        onChange={(event, data) => this.setState({dashMpdReqMode: data.value})}
                                                    />
                                                </Form.Group>
                                                : null}
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Initialization File Request Mode
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.dashInitReqMode}
                                                    options={initializationFileReqOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({dashInitReqMode: data.value})}
                                                />
                                            </Form.Group>
                                            {!oauth.VODOnlyLicensePresent ?
                                                <Form.Group grouped>
                                                    <Label
                                                        className="left-align-label-min200"
                                                        style={{paddingLeft: '10%'}}
                                                    >
                                                        Media File Start Position
                                                    </Label>
                                                    <Dropdown
                                                        search
                                                        value={this.state.dashMediaFileStartPos}
                                                        options={mediaFileStartPosOptions}
                                                        selection
                                                        onChange={(event, data) => this.setState({dashMediaFileStartPos: data.value})}
                                                    />
                                                </Form.Group>
                                                : null}
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Profile Check Mode
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.dashProfileChkMode}
                                                    options={dashProfileChkModeOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({dashProfileChkMode: data.value})}
                                                />
                                            </Form.Group>
                                            {!oauth.VODOnlyLicensePresent ?
                                                <OAuth.Feature DAI>
                                                    <Form.Group grouped>
                                                        <Checkbox
                                                            className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                            checked={this.state.dashDaiEnable}
                                                            onChange={(e: any, data: any) => this.setState({dashDaiEnable: data.checked})}
                                                        />
                                                        <Label className="left-align-label-500">
                                                            Enable Dynamic Ad Insertion
                                                        </Label>
                                                    </Form.Group>
                                                </OAuth.Feature>
                                                : null}
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Variant Name Options</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashVarNameOptPatternMatch}
                                                    onChange={(e: any, data: any) => this.setState({dashVarNameOptPatternMatch: data.checked})}
                                                />
                                                <Label className="left-align-label-500">
                                                    Pattern Match
                                                </Label>
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment>
                                        <Form>
                                            {dashVariantNameOptions.map((nameOption, index) => {
                                                return <Form.Group grouped key={nameOption.stateName}>
                                                    <Checkbox
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state[nameOption.stateName]}
                                                        onChange={(e: any, data: any) => this.setState({
                                                            ...this.state,
                                                            [nameOption.stateName]: data.checked
                                                        })}
                                                    />
                                                    <Label className="left-align-label-500">
                                                        {nameOption.label}
                                                    </Label>
                                                </Form.Group>;
                                            })}
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    During advertisement opportunity
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashVarNameOptDaiPeriodId}
                                                    onChange={(e: any, data: any) => this.setState({dashVarNameOptDaiPeriodId: data.checked})}
                                                />
                                                <Label className="left-align-label-500">
                                                    Period Identifier
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Checkbox
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashVarNameOptDaiAd}
                                                    onChange={(e: any, data: any) => this.setState({dashVarNameOptDaiAd: data.checked})}
                                                />
                                                <Label className="left-align-label-500">
                                                    Append 'ad'
                                                </Label>
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Disable"
                                                    name="radioGroup"
                                                    value="disabled"
                                                    checked={this.state.dashAutoStartComp === 'disabled'}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="All"
                                                    name="radioGroup"
                                                    value="all"
                                                    checked={this.state.dashAutoStartComp === 'all'}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                                />
                                                <Label className="right-align-label-width"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'all'}
                                                    className="config-checkbox"
                                                    label="Enable sub-representations"
                                                    checked={this.state.dashAutoStartCompAllSubRep}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllSubRep: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompAllVideo}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllVideo: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Video
                                                </Label>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.dashAutoStartComp !== 'all' || (!this.state.dashAutoStartCompAllVideo)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeAllVideo}
                                                        // onChange={(e: any, data: any) => this.setState({dashQoeAllVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(1)}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'all') || (!this.state.dashAutoStartCompAllVideo)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.dashAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.dashQoeAllVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeAllPixel}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeAllPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.dashQoeAllVideo ? true : false)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompAllAudio}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllAudio: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Audio
                                                </Label>
                                            </Form.Group>
                                            <OAuth.Feature QoE>

                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.dashAutoStartComp !== 'all' || (!this.state.dashAutoStartCompAllAudio)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeAllAudio}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeAllAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'all') || (!this.state.dashAutoStartCompAllAudio)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.dashAutoStartComp !== 'all' || (!this.state.dashAutoStartCompAllAudio) || (!this.state.dashAutoStartCompAllSubRep)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeAllSubRep}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeAllSubRep: data.checked})}
                                                    />
                                                    <Label
                                                        className={this.state.dashAutoStartComp !== 'all' || (!this.state.dashAutoStartCompAllAudio) || (!this.state.dashAutoStartCompAllSubRep)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Sub-Reps
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompAllText}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllText: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Text Track
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'all'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompAllImage}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompAllImage: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'all')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Image
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Limited"
                                                    name="radioGroup"
                                                    value="limited"
                                                    checked={this.state.dashAutoStartComp === 'limited'}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartComp: data.value})}
                                                />
                                                <Label className="right-align-label-width"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'limited'}
                                                    className="config-checkbox"
                                                    label="Enable sub-representations"
                                                    checked={this.state.dashAutoStartCompLimitSubRep}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitSubRep: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompLimitVideo}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitVideo: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min150-disabled'
                                                        : 'left-align-label-min150'
                                                    }
                                                >
                                                    Video
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitVideo)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <div className="left-align-label-min150">
                                                    <Input
                                                        disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitVideo))}
                                                        maxLength={63}
                                                        className="small-input-leftMargin"
                                                        value={this.state.dashAutoStartCompLimitVideoVar}
                                                        onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitVideoVar: data.value})}
                                                    /></div>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitVideo)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeLimitVideo}
                                                        // onChange={(e: any, data: any) => this.setState({dashQoeLimitVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(2)}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitVideo)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={(this.state.dashAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.dashQoeLimitVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeLimitPixel}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeLimitPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.dashQoeLimitVideo ? true : false)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompLimitAudio}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitAudio: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Audio
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitAudio)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <div className="left-align-label-min150">
                                                    <Input
                                                        disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitAudio))}
                                                        maxLength={63}
                                                        className="small-input-leftMargin"
                                                        value={this.state.dashAutoStartCompLimitAudioVar}
                                                        onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitAudioVar: data.value})}
                                                    /></div>
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.dashAutoStartComp !== 'limited' || (!this.state.dashAutoStartCompLimitAudio)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeLimitAudio}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeLimitAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitAudio)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Label className="left-align-label-85"/>
                                                    <Checkbox
                                                        disabled={this.state.dashAutoStartComp !== 'limited' || (!this.state.dashAutoStartCompLimitAudio) || (!this.state.dashAutoStartCompLimitSubRep)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.dashQoeLimitSubRep}
                                                        onChange={(e: any, data: any) => this.setState({dashQoeLimitSubRep: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitAudio) || (!this.state.dashAutoStartCompLimitSubRep)
                                                            ? 'left-align-label-min340-disabled'
                                                            : 'left-align-label-min340'
                                                        }
                                                    >
                                                        Audio Sub-Reps
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompLimitText}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitText: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Text Track
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitText)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <Input
                                                    disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitText))}
                                                    maxLength={63}
                                                    className="small-input-leftMargin"
                                                    value={this.state.dashAutoStartCompLimitTextVar}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitTextVar: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="left-align-label-35"/>
                                                <Checkbox
                                                    disabled={this.state.dashAutoStartComp !== 'limited'}
                                                    className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                    checked={this.state.dashAutoStartCompLimitImage}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitImage: data.checked})}
                                                />
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited')
                                                        ? 'left-align-label-min240-disabled'
                                                        : 'left-align-label-min240'
                                                    }
                                                >
                                                    Image
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitImage)
                                                        ? 'right-align-label-width200-disabled'
                                                        : 'right-align-label-width200'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <Input
                                                    disabled={((this.state.dashAutoStartComp !== 'limited') || (!this.state.dashAutoStartCompLimitImage))}
                                                    maxLength={63}
                                                    className="small-input-leftMargin"
                                                    value={this.state.dashAutoStartCompLimitImageVar}
                                                    onChange={(e: any, data: any) => this.setState({dashAutoStartCompLimitImageVar: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/mpegAdaptiveStreamConfig.tsx